import React from "react";
import { Navigate } from "react-router-dom";
import { useClaims } from "../features/auth/useClaims";
import { paths } from "./paths";
import LoadingScreen from "../components/common/LoadingScreen";

/**
 * Gates a route by a Module.Action permission code (handoff §4: never
 * hardcode role names, always check the permissions array from the token).
 */
const PermissionRoute = ({ code, children }) => {
  const { isLoading, permissions } = useClaims();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!permissions.includes(code)) {
    return <Navigate to={paths.dashboard} replace />;
  }

  return children;
};

export default PermissionRoute;
